<template>
  <span
    class="inline-flex items-center justify-center w-6 h-6 transition rounded-full bg-secondary-15 hover:bg-secondary-20 private-mode-button"
  >
    <aha-icon
      class="text-secondary-50 private-mode-icon"
      v-if="presentation.privateMode"
      name="hide"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      v-tooltip="'Private: Audience cannot see or interact with your slides'"
    />

    <aha-icon
      class="text-secondary-50 private-mode-icon"
      v-else
      name="unhide"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      v-tooltip="'Public: Audience can see and interact with your slides'"
    />
  </span>
</template>
<script>
export default {
  name: 'PrivateModeButton',
  props: {
    presentation: {
      required: true,
      type: Object,
    },
  },
}
</script>
